export enum userPolicyFeatureCode {
  "BUY_NEW_LINE" = "BUY-NEW-LINE",
  "RECONTRACT_LINE" = "RECONTRACT-LINE",
  "CHANGE_MOBI_PLAN" = "CHANGE-MOBI-PLAN",
  "BUY_PORT_IN" = "BUY-PORT-IN",
  "BUY_DEVICE_ONLY" = "BUY-DEVICE-ONLY",
  "BUY_ACCE_ONLY" = "BUY-ACCE-ONLY",
  "TER_MOB_LINE" = "TER-MOB-LINE",
  "BUY_MOBI_ADDON" = "BUY-MOBI-ADDON",
  "CEASE_MOBI_ADDON" = "CEASE-MOBI-ADDON",
  "REP_SIM_CARD" = "REP-SIM-CARD",
  "REPORT_LOST_MOBI" = "REPORT-LOST-MOBI",
  "TRAN_MOBI_LINE" = "TRAN-MOBI-LINE",
  "SUS_MOBI_LINE" = "SUS-MOBI-LINE",
  "UNSUS_MOBI_LINE" = "UNSUS-MOBI-LINE",
  "SIM_ACT_REQUEST" = "SIM-ACT-REQUEST",
  "POP_STATION" = "POP-STATION",
  "OFFICE_DEL" = "OFFICE-DEL",
  "RESI_ADDR" = "RESI-ADDR",
  "CHG_PAY_METHOD" = "CHG-PAY-METHOD",
  "CREDIT_CARD_D" = "CREDIT-CARD-D",
  "CREDIT_CARD_M" = "CREDIT-CARD-M",
  "CREDIT_TERM" = "CREDIT-TERM",
  "TECH_FUNDS" = "TECH-FUNDS",
  "SPLIT_PAY" = "SPLIT-PAY",
  "GIRO" = "GIRO",
  "CRT_NEW_ACCT" = "CRT-NEW-ACCT",
  "BILL_EXIST_ACCT" = "BILL-EXIST-ACCT",
  "CHANGE_BIL_ADDR" = "CHANGE-BIL-ADDR",
  "CHANGE_USERNAME" = "CHANGE-USERNAME",
  "ESHOP_AGENT_ASST" = "ESHOP-AGENT-ASST",
  "REFIT_MOBI_LINE" = "REFIT-MOBI-LINE",
  "MRC_ENROLL" = "MRC-ENROLL",
  "ESHOP_ADM_PRTL" = "ESHOP-ADM-PRTL",
  "CHANGE_MOBI_NUM" = "CHANGE-MOBI-NUM",
  "VIEW_CATALOGUE" = "VIEW-CATALOGUE",
  "USER_PLANS" = "USER-PLANS",
  "RESERVE_NUMBER" = "RESERVE-NUMBER",
  "BUY_NUM_SHA" = "BUY-NUM-SHA",
  "MOBI_ORDER_STATUS" = "MOBI-ORDER-STATUS",
  "SMT_TEMPLATE_BUY" = "SMT-TEMPLATE-BUY",
  "SMT_TEMPLATE_CREATE"= "SMT-TEMPLATE-CREATE",
  "WAIVE_DELIVERY_FEE" = "WAIVE-DELIVERY-FEE",
  "WAIVE_PENALTY_FEE" = "WAIVE-PENALTY-FEE",
  "BUY_E_FORM" = "BUY-E-FORM"
}

enum userPolicyFeatureName {
  "BUY_NEW_LINE" = "Purchase a new line",
  "RECONTRACT_LINE" = "Recontract a line",
  "CHANGE_MOBI_PLAN" = "Change mobile plan",
  "BUY_PORT_IN" = "Port-in",
  "BUY_DEVICE_ONLY" = "Purchase device only",
  "BUY_ACCE_ONLY" = "Purchase accessories only",
  "TER_MOB_LINE" = "Terminate a mobile line",
  "BUY_MOBI_ADDON" = "Buy mobile add-on",
  "CEASE_MOBI_ADDON" = "Cease mobile add-on",
  "REP_SIM_CARD" = "Replace SIM card",
  "REPORT_LOST_MOBI" = "Report lost mobile",
  "TRAN_MOBI_LINE" = "Transfer a mobile line",
  "SUS_MOBI_LINE" = "Suspend a mobile line",
  "UNSUS_MOBI_LINE" = "Unsuspend a mobile line",
  "SIM_ACT_REQUEST" = "SIM activation request",
  "POP_STATION" = "POPstation",
  "OFFICE_DEL" = "Office delivery",
  "RESI_ADDR" = "Residential address",
  "CHG_PAY_METHOD" = "Change payment method",
  "CREDIT_CARD_D" = "Credit card/Debit card",
  "CREDIT_CARD_M" = "Credit card/Debit card",
  "CREDIT_TERM" = "Credit term",
  "TECH_FUNDS" = "Tech funds",
  "SPLIT_PAY" = "Split payment",
  "GIRO" = "GIRO",
  "CRT_NEW_ACCT" = "Create new billing account",
  "BILL_EXIST_ACCT" = "Bill existing billing account",
  "CHANGE_BIL_ADDR" = "Change billing address",
  "CHANGE_USERNAME" = "Change username",
  "ESHOP_AGENT_ASST" = "Agent assist",
  "REFIT_MOBI_LINE" = "Refit a mobile line",
  "MRC_ENROLL" = "MRC enrollment",
  "ESHOP_ADM_PRTL" = "Admin portal",
  "CHANGE_MOBI_NUM" = "Change Mobile Number",
  "VIEW_CATALOGUE" = "Catalogue",
  "USER_PLANS" = "Check Eligibility",
  "RESERVE_NUMBER" = "Reserve Number",
  "BUY_NUM_SHA" = "Number Share",
  "MOBI_ORDER_STATUS" = 'Order Status',
  "SMT_TEMPLATE_BUY" = 'Smart Template',
  "SMT_TEMPLATE_CREATE" = 'Smart Template Create',
  "WAIVE_DELIVERY_FEE" = "Waive delivery fees",
  "WAIVE_PENALTY_FEE" = "Waive penalty fees",
  "BUY_E_FORM" = "eFORM"
}

enum userPolicyKey {
  POPSTATION = 'POPSTATION',
  NORMAL = 'NORMAL',
  RESIDENTIAL = 'RESIDENTIAL',
  CREDIT_CARD = 'CREDIT_CARD',
  CREDIT_TERM = 'CREDIT_TERM',
  TECHFUND = 'TECHFUND',
  BILLING_ACCOUNT = 'BILLING_ACCOUNT'
}

enum userPolicyMenuKey {
  changeuserdetails = 'changeuserdetails',
  billingaccount = 'billingaccount',
  billingAcountDetails = 'billingAcountDetails',
  address = 'address',
  catalogue = 'catalogue',
  checkEligibility = 'checkEligibility',
  activateSim = 'simactivation',
  transferMobileLine = "transfermobileline",
  reserveNumber = "reserveNumber",
  transactionhistory = 'transactionhistory',
  eform = 'eform'
}

export const userPolicy = [
  {
    "featureCode": userPolicyFeatureCode.BUY_NEW_LINE,
    "featureName": userPolicyFeatureName.BUY_NEW_LINE
  },
  {
    "featureCode": userPolicyFeatureCode.RECONTRACT_LINE,
    "featureName": userPolicyFeatureName.RECONTRACT_LINE
  },
  {
    "featureCode": userPolicyFeatureCode.CHANGE_MOBI_PLAN,
    "featureName": userPolicyFeatureName.CHANGE_MOBI_PLAN
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_PORT_IN,
    "featureName": userPolicyFeatureName.BUY_PORT_IN
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_DEVICE_ONLY,
    "featureName": userPolicyFeatureName.BUY_DEVICE_ONLY
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_ACCE_ONLY,
    "featureName": userPolicyFeatureName.BUY_ACCE_ONLY
  },
  {
    "featureCode": userPolicyFeatureCode.TER_MOB_LINE,
    "featureName": userPolicyFeatureName.TER_MOB_LINE
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_MOBI_ADDON,
    "featureName": userPolicyFeatureName.BUY_MOBI_ADDON
  },
  {
    "featureCode": userPolicyFeatureCode.CEASE_MOBI_ADDON,
    "featureName": userPolicyFeatureName.CEASE_MOBI_ADDON
  },
  {
    "featureCode": userPolicyFeatureCode.REP_SIM_CARD,
    "featureName": userPolicyFeatureName.REP_SIM_CARD
  },
  {
    "featureCode": userPolicyFeatureCode.REPORT_LOST_MOBI,
    "featureName": userPolicyFeatureName.REPORT_LOST_MOBI
  },
  {
    "featureCode": userPolicyFeatureCode.TRAN_MOBI_LINE,
    "featureName": userPolicyFeatureName.TRAN_MOBI_LINE
  },
  {
    "featureCode": userPolicyFeatureCode.SUS_MOBI_LINE,
    "featureName": userPolicyFeatureName.SUS_MOBI_LINE
  },
  {
    "featureCode": userPolicyFeatureCode.UNSUS_MOBI_LINE,
    "featureName": userPolicyFeatureName.UNSUS_MOBI_LINE
  },
  {
    "featureCode": userPolicyFeatureCode.SIM_ACT_REQUEST,
    "featureName": userPolicyFeatureName.SIM_ACT_REQUEST
  },
  {
    "featureCode": userPolicyFeatureCode.POP_STATION,
    "featureName": userPolicyFeatureName.POP_STATION,
    key: userPolicyKey.POPSTATION
  },
  {
    "featureCode": userPolicyFeatureCode.OFFICE_DEL,
    "featureName": userPolicyFeatureName.OFFICE_DEL,
    key: userPolicyKey.NORMAL
  },
  {
    "featureCode": userPolicyFeatureCode.RESI_ADDR,
    "featureName": userPolicyFeatureName.RESI_ADDR,
    key: userPolicyKey.RESIDENTIAL
  },
  {
    "featureCode": userPolicyFeatureCode.CHG_PAY_METHOD,
    "featureName": userPolicyFeatureName.CHG_PAY_METHOD
  },
  {
    "featureCode": userPolicyFeatureCode.CREDIT_CARD_D,
    "featureName": userPolicyFeatureName.CREDIT_CARD_D,
    key: userPolicyKey.CREDIT_CARD
  },
  {
    "featureCode": userPolicyFeatureCode.CREDIT_CARD_M,
    "featureName": userPolicyFeatureName.CREDIT_CARD_M,
    key: userPolicyKey.CREDIT_CARD
  },
  {
    "featureCode": userPolicyFeatureCode.CREDIT_TERM,
    "featureName": userPolicyFeatureName.CREDIT_TERM,
    key: userPolicyKey.CREDIT_TERM
  },
  {
    "featureCode": userPolicyFeatureCode.TECH_FUNDS,
    "featureName": userPolicyFeatureName.TECH_FUNDS,
    key: userPolicyKey.TECHFUND

  },
  {
    "featureCode": userPolicyFeatureCode.SPLIT_PAY,
    "featureName": userPolicyFeatureName.SPLIT_PAY
  },
  {
    "featureCode": userPolicyFeatureCode.GIRO,
    "featureName": userPolicyFeatureName.GIRO
  },
  {
    "featureCode": userPolicyFeatureCode.CRT_NEW_ACCT,
    "featureName": userPolicyFeatureName.CRT_NEW_ACCT
  },
  {
    "featureCode": userPolicyFeatureCode.BILL_EXIST_ACCT,
    "featureName": userPolicyFeatureName.BILL_EXIST_ACCT,
    key: userPolicyKey.BILLING_ACCOUNT
  },
  {
    "featureCode": userPolicyFeatureCode.CHANGE_BIL_ADDR,
    "featureName": userPolicyFeatureName.CHANGE_BIL_ADDR
  },
  {
    "featureCode": userPolicyFeatureCode.CHANGE_USERNAME,
    "featureName": userPolicyFeatureName.CHANGE_USERNAME
  },
  {
    "featureCode": userPolicyFeatureCode.ESHOP_AGENT_ASST,
    "featureName": userPolicyFeatureName.ESHOP_AGENT_ASST
  },
  {
    "featureCode": userPolicyFeatureCode.REFIT_MOBI_LINE,
    "featureName": userPolicyFeatureName.REFIT_MOBI_LINE
  },
  {
    "featureCode": userPolicyFeatureCode.MRC_ENROLL,
    "featureName": userPolicyFeatureName.MRC_ENROLL
  },
  {
    "featureCode": userPolicyFeatureCode.ESHOP_ADM_PRTL,
    "featureName": userPolicyFeatureName.ESHOP_ADM_PRTL
  },
  {
    "featureCode": userPolicyFeatureCode.CHANGE_MOBI_NUM,
    "featureName": userPolicyFeatureName.CHANGE_MOBI_NUM
  },
  {
    "featureCode": userPolicyFeatureCode.VIEW_CATALOGUE,
    "featureName": userPolicyFeatureName.VIEW_CATALOGUE
  },
  {
    "featureCode": userPolicyFeatureCode.USER_PLANS,
    "featureName": userPolicyFeatureName.USER_PLANS
  },
  {
    "featureCode": userPolicyFeatureCode.RESERVE_NUMBER,
    "featureName": userPolicyFeatureName.RESERVE_NUMBER
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_NUM_SHA,
    "featureName": userPolicyFeatureName.BUY_NUM_SHA
  },
  {
    "featureCode": userPolicyFeatureCode.MOBI_ORDER_STATUS,
    "featureName": userPolicyFeatureName.MOBI_ORDER_STATUS
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_E_FORM,
    "featureName": userPolicyFeatureName.BUY_E_FORM
  },
]

////checks for permission for OrderType
export const userPolicyMenu = [
  {
    "featureCode": userPolicyFeatureCode.BUY_NEW_LINE,
    "featureName": userPolicyFeatureName.BUY_NEW_LINE,
    ordertype: "NEWLINE"
  },
  {
    "featureCode": userPolicyFeatureCode.RECONTRACT_LINE,
    "featureName": userPolicyFeatureName.RECONTRACT_LINE,
    ordertype: "RECONTRACT"
  },
  {
    "featureCode": userPolicyFeatureCode.CHANGE_MOBI_PLAN,
    "featureName": userPolicyFeatureName.CHANGE_MOBI_PLAN,
    ordertype: "CHANGE_PLAN"
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_PORT_IN,
    "featureName": userPolicyFeatureName.BUY_PORT_IN,
    ordertype: "NUMBER_PORT"
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_DEVICE_ONLY,
    "featureName": userPolicyFeatureName.BUY_DEVICE_ONLY,
    ordertype: "RRP_EQUIPMENT"
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_ACCE_ONLY,
    "featureName": userPolicyFeatureName.BUY_ACCE_ONLY,
    ordertype: "RRP_ACCESSORY"
  },
  {
    "featureCode": userPolicyFeatureCode.TER_MOB_LINE,
    "featureName": userPolicyFeatureName.TER_MOB_LINE,
    ordertype: "TERMINATE_NUMBER"
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_MOBI_ADDON,
    "featureName": userPolicyFeatureName.BUY_MOBI_ADDON,
    ordertype: "BUY_ADD_ONS"
  },
  {
    "featureCode": userPolicyFeatureCode.CEASE_MOBI_ADDON,
    "featureName": userPolicyFeatureName.CEASE_MOBI_ADDON,
    ordertype: "CEASE_ADDONS"
  },
  {
    "featureCode": userPolicyFeatureCode.REP_SIM_CARD,
    "featureName": userPolicyFeatureName.REP_SIM_CARD,
    ordertype: "REPLACE_SIM"
  },
  {
    "featureCode": userPolicyFeatureCode.REPORT_LOST_MOBI,
    "featureName": userPolicyFeatureName.REPORT_LOST_MOBI,
    ordertype: "REPORT_LOST"
  },
  {
    "featureCode": userPolicyFeatureCode.TRAN_MOBI_LINE,
    "featureName": userPolicyFeatureName.TRAN_MOBI_LINE,
    ordertype: "TRANSFER_MOBILE_LINE"
  },
  {
    "featureCode": userPolicyFeatureCode.SUS_MOBI_LINE,
    "featureName": userPolicyFeatureName.SUS_MOBI_LINE,
    ordertype: "SUSPEND_LINE"
  },
  {
    "featureCode": userPolicyFeatureCode.UNSUS_MOBI_LINE,
    "featureName": userPolicyFeatureName.UNSUS_MOBI_LINE,
    ordertype: "UNSUSPEND_LINE"
  },
  {
    "featureCode": userPolicyFeatureCode.SIM_ACT_REQUEST,
    "featureName": userPolicyFeatureName.SIM_ACT_REQUEST,
    ordertype: "ACTIVATE_SIM"
  },
  {
    "featureCode": userPolicyFeatureCode.CHANGE_MOBI_NUM,
    "featureName": userPolicyFeatureName.CHANGE_MOBI_NUM,
    ordertype: "CHANGE_MOBILE_NUMBER"
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_NUM_SHA,
    "featureName": userPolicyFeatureName.BUY_NUM_SHA,
    ordertype: 'NUMBER_SHARE'
  },
  {
    "featureCode": userPolicyFeatureCode.REFIT_MOBI_LINE,
    "featureName": userPolicyFeatureName.REFIT_MOBI_LINE,
     ordertype: 'REFIT_LINE'
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_E_FORM,
    "featureName": userPolicyFeatureName.BUY_E_FORM,
    ordertype: "BUY_E_FORM"
  },
]

////used for ManageService Layout transaction(without transactionType) & Account menu Permission
////can be consolidated with APPCONFIG common page
export const userPolicyAccountMenu = [
  {
    "featureCode": userPolicyFeatureCode.CHANGE_USERNAME,
    "featureName": userPolicyFeatureName.CHANGE_USERNAME,
    key: userPolicyMenuKey.changeuserdetails
  },
  {
    "featureCode": userPolicyFeatureCode.CHANGE_BIL_ADDR,
    "featureName": userPolicyFeatureName.CHANGE_BIL_ADDR,
    key: userPolicyMenuKey.billingaccount
  },
  {
    "featureCode": userPolicyFeatureCode.CHANGE_BIL_ADDR,
    "featureName": userPolicyFeatureName.CHANGE_BIL_ADDR,
    key: userPolicyMenuKey.billingAcountDetails
  },
  {
    "featureCode": userPolicyFeatureCode.OFFICE_DEL,
    "featureName": userPolicyFeatureName.OFFICE_DEL,
    key: userPolicyMenuKey.address
  },
  {
    "featureCode": userPolicyFeatureCode.VIEW_CATALOGUE,
    "featureName": userPolicyFeatureName.VIEW_CATALOGUE,
    key: userPolicyMenuKey.catalogue
  },
  {
    "featureCode": userPolicyFeatureCode.USER_PLANS,
    "featureName": userPolicyFeatureName.USER_PLANS,
    key: userPolicyMenuKey.checkEligibility
  },
  {
    "featureCode": userPolicyFeatureCode.SIM_ACT_REQUEST,
    "featureName": userPolicyFeatureName.SIM_ACT_REQUEST,
    key: userPolicyMenuKey.activateSim
  },
  {
    "featureCode": userPolicyFeatureCode.TRAN_MOBI_LINE,
    "featureName": userPolicyFeatureName.TRAN_MOBI_LINE,
    key: userPolicyMenuKey.transferMobileLine
  },
  {
    "featureCode": userPolicyFeatureCode.RESERVE_NUMBER,
    "featureName": userPolicyFeatureName.RESERVE_NUMBER,
    key: userPolicyMenuKey.reserveNumber
  },
  {
    "featureCode": userPolicyFeatureCode.MOBI_ORDER_STATUS,
    "featureName": userPolicyFeatureName.MOBI_ORDER_STATUS,
    key: userPolicyMenuKey.transactionhistory
  },
  {
    "featureCode": userPolicyFeatureCode.BUY_E_FORM,
    "featureName": userPolicyFeatureName.BUY_E_FORM,
    key: userPolicyMenuKey.eform
  }
]
